export default "__VITE_ASSET__UyEBjxg6__"